import { createSlice } from "@reduxjs/toolkit";
import { pasVeldenToe } from "../../lib/voorbeeldopmaak";
import { metGastgroepen, voorbeeldPaneel } from "../../lib/gastgroepen";
const initialState = {
  widgetConfig:null,
  WidgetSetting: [],
  blockedDates: [],
  widgetSetupId: "",
  defaultLanguage: "",
  key: "",
  buttonPosition: "",
  resType: "",
    widgetPosition: "",
    floating : "",
  languageData:[],
  buttonText:'',
  languageLoaded: false, // New flag to track if language data is loaded
  webShopMenuPosition:'',
  widgetUrl:'',
  guestId:'',
  guestInfo:{},
  CombinationLang:{},
  deviceId:null,
  css:[],
  // Het live voorbeeld op de kleurenpagina van het dashboard (golf 1B): { velden, opmaak } of null.
  voorbeeld:null,
  // Het live voorbeeld van het tabblad Weergave / het scherm Gastgroepen (golf 2D): welk vak open staat ("gasten", "tijden") of null.
  voorbeeldPaneel:null
};
export const addGuestSlice = createSlice({
  name: "widgetSettings",
  initialState,
  reducers: {
    updateWidgetConfig: (state, action) => {
      // Alleen de gastgroepen van deze widget (weergave.gastgroepen, golf 2D); de namen van de winkel blijven in alleVelden.
      state.widgetConfig = metGastgroepen(action.payload);
    },
    updateWidgetSetting: (state, action) => {
      state.WidgetSetting = action.payload;
    },
    updateBlockedDates: (state, action) => {
      state.blockedDates = action.payload;
    },
    updateWidgetSetupId: (state, action) => {
      state.widgetSetupId = action.payload;
    },
    updateDefaultLanguage: (state, action) => {
      state.defaultLanguage = action.payload;
    },
    updateKey: (state, action) => {
      state.key = action.payload;
    },
    updateButtonPosition: (state, action) => {
      state.buttonPosition = action.payload;
    },
    updateResType: (state, action) => {
      state.resType = action.payload;
    },
    updateWidgetPosition: (state, action) => {
      state.widgetPosition = action.payload;
      },
      updateFloating: (state, action) => {
          state.floating = action.payload;
      },
      updateLanguageData: (state, action) => {
        state.languageData = action.payload;
      },
      updateButtonText: (state, action) => {
        state.buttonText = action.payload;
      },
      setLanguageLoaded(state, action) {
        state.languageLoaded = action.payload;
      },
      updateDeliveryType: (state, action) => {
        state.deliveryType = action.payload;
      },
      updateGuestId:(state, action) => {
        state.guestId = action.payload;
      },
      updateGuestInfo:(state, action) => {
        state.guestInfo = action.payload;
      },
      resetWidget:(state, action) => {
        // Het voorbeeld van het dashboard blijft staan als de gast opnieuw begint (golf 1B).
        return { ...initialState, voorbeeld: state.voorbeeld, voorbeeldPaneel: state.voorbeeldPaneel }
  },
  updateCombinationLang:(state, action) => {
    state.CombinationLang = action.payload;
  },
  updateDeviceId:(state,action)=>{
    state.deviceId=action.payload
  },
  updateWidgetUrl:(state,action)=>{
    state.widgetUrl=action.payload
  },
  updateCss:(state,action)=>{
    // In het voorbeeld gaan de kleuren van het dashboard voor, ook als de opmaak pas na het eerste bericht binnenkomt.
    state.css=state.voorbeeld ? pasVeldenToe(action.payload, state.voorbeeld.velden) : action.payload
  },
  zetVoorbeeld:(state,action)=>{
    state.voorbeeld=action.payload
    state.css=pasVeldenToe(state.css, action.payload?.velden)
  },
  zetVoorbeeldPaneel:(state,action)=>{
    state.voorbeeldPaneel=voorbeeldPaneel(action.payload)
  }

  },
});

// Action creators are generated for each case reducer function
export const {
  updateDeviceId,
  resetWidget,
  updateWidgetConfig,
  updateWidgetSetting,
  updateWidgetSetupId,
  updateDefaultLanguage,
  updateKey,
  updateButtonPosition,
  updateResType,
  updateWidgetPosition,
    updateBlockedDates,
    updateFloating,
    updateLanguageData,
    updateButtonText,
    setLanguageLoaded,
    updateDeliveryType,
    updateWidgetUrl,
    updateGuestId,
    updateGuestInfo,
    updateCombinationLang,
    updateCss,
    zetVoorbeeld,
    zetVoorbeeldPaneel
} = addGuestSlice.actions;

export default addGuestSlice.reducer;
